import React from 'react';
import axios from 'helpers/axios';

import { Form, Container, Title, TextInput, Button } from 'ui/components/styled';
import { useToasts, useCompany } from 'hooks';

export const AddCompany = ({ onClose, onSuccess }) => {
  const [state, setState] = React.useState({ name: '' });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();
  const { refreshCompanies } = useCompany();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.post('/companies/', {
        name: state.name,
      });
      if (response.status === 201) {
        removeAllToasts();
        successToast('Company added successfully!');
        refreshCompanies();
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess();
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Add Company.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Add new company
        </Title>
      </Container>
      <Container mb="m">
        <TextInput
          name="name"
          variant="minimal"
          placeholder="Company name"
          value={state.name}
          onChange={handleChange}
          required
          autoFocus
        />
      </Container>
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width="30%" disabled={preventSubmit}>
          Save
        </Button>
      </Container>
    </Form>
  );
};
